module.exports = __webpack_public_path__ + "img/GAME_AIRPLANE2.59832f64.jpg";